/* unplugin-vue-components disabled */const { ref, reactive, onBeforeMount } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-518868fb"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "main-container" };
const _hoisted_2 = _withScopeId(() => (0, vue_2.createElementVNode)("div", { class: "youtoo-box" }, [
    (0, vue_2.createElementVNode)("div", { class: "logo" }),
    (0, vue_2.createElementVNode)("div", { class: "slogan" }, "友图,让自动化更简单!")
], -1));
const _hoisted_3 = { class: "form-box" };
const _hoisted_4 = { id: "header" };
const _hoisted_5 = _withScopeId(() => (0, vue_2.createElementVNode)("h2", { class: "form-title" }, "登录", -1));
const _hoisted_6 = _withScopeId(() => (0, vue_2.createElementVNode)("span", null, "没有账号,", -1));
const _hoisted_7 = _withScopeId(() => (0, vue_2.createElementVNode)("h2", { class: "form-title" }, "注册", -1));
const _hoisted_8 = _withScopeId(() => (0, vue_2.createElementVNode)("span", null, "已有账号,", -1));
const _hoisted_9 = _withScopeId(() => (0, vue_2.createElementVNode)("h2", { class: "form-title" }, "重置密码", -1));
const _hoisted_10 = { class: "sms-code-wrap" };
const _hoisted_11 = { class: "sms-code-wrap" };
const _hoisted_12 = { class: "form-btn-wrap" };
const _hoisted_13 = _withScopeId(() => (0, vue_2.createElementVNode)("br", null, null, -1));
const utils_1 = require("@/utils");
const loading_1 = require("@/utils/loading");
const base64_1 = require("@/utils/base64");
const one_message_1 = require("@/utils/one_message");
const router_1 = tslib_1.__importDefault(require("@/router"));
const user_1 = require("@/service/user");
var FORM_MODE;
(function (FORM_MODE) {
    FORM_MODE[FORM_MODE["LOGIN"] = 0] = "LOGIN";
    FORM_MODE[FORM_MODE["SIGN_UP"] = 1] = "SIGN_UP";
    FORM_MODE[FORM_MODE["RESET_PWD"] = 2] = "RESET_PWD";
})(FORM_MODE || (FORM_MODE = {}));
const timeLimit = 60;
exports.default = (0, vue_1.defineComponent)({
    __name: 'Login',
    setup(__props) {
        const isSavePwd = ref(false);
        const showPassword = ref(false);
        const showPwd2 = ref(false);
        const curFormMode = ref(FORM_MODE.LOGIN);
        const signUpFormEl = ref();
        const isSigning = ref(false);
        const isChanging = ref(false);
        const loginForm = reactive({
            account: utils_1.Utils.isProd() ? "" : "john",
            password: ""
        });
        const signUpResetForm = reactive({
            pwd: '',
            pwd2: '',
            smsCode: '',
            phone: ''
        });
        const resetSignUpResetForm = () => {
            signUpResetForm.pwd = '';
            signUpResetForm.pwd2 = '';
            signUpResetForm.smsCode = '';
            signUpResetForm.phone = '';
        };
        const nicknameValid = (rule, value, callback) => {
            console.log(rule, value);
            if (!value) {
                return;
            }
            else if (value.length > 15) {
                callback(new Error('昵称长度不能超过15个字符'));
            }
            else if (!/^[\u4e00-\u9fa5a-zA-Z0-9]+$/.test(value)) {
                callback(new Error('昵称不能含有空格或特殊字符'));
            }
            else {
                callback();
            }
        };
        const pwdValid = (rule, value, callback) => {
            console.log(rule, value);
            if (!value || value.length === 0) {
                callback(new Error('请输入密码'));
            }
            else if (value.length < 6) {
                callback(new Error('密码长度不能少于6位'));
            }
            else if (value.length > 18) {
                callback(new Error('密码长度不能大于18位'));
            }
            else {
                callback();
            }
        };
        const pwd2Valid = (rule, value, callback) => {
            console.log(rule, value);
            if (value !== signUpResetForm.pwd) {
                callback(new Error('两次密码输入不一致'));
            }
            else {
                callback();
            }
        };
        const phoneValid = (rule, value, callback) => {
            console.log(rule, value);
            if (!value || value.length === 0) {
                callback(new Error('请输入手机号码'));
            }
            else if (!/^1[0-9]{10}$/.test(value)) {
                callback(new Error('手机号格式不正确'));
            }
            else {
                callback();
            }
        };
        const accountValid = (rule, value, callback) => {
            if (!value || value.length === 0) {
                callback(new Error('请输入用户名'));
            }
            else {
                callback();
            }
        };
        const passwordValid = (rule, value, callback) => {
            if (!value || value.length === 0) {
                callback(new Error('请输入密码'));
            }
            else {
                callback();
            }
        };
        const smsCodeValid = (rule, value, callback) => {
            if (!value || value.length === 0) {
                callback(new Error('请输入验证码'));
            }
            else if (value.length < 4) {
                callback(new Error('验证码不能少于4位'));
            }
            else if (value.length > 6) {
                callback(new Error('验证码不能多于6位'));
            }
            else {
                callback();
            }
        };
        const signUpResetRules = reactive({
            pwd: [{ validator: pwdValid, trigger: 'blur', required: true }],
            pwd2: [{ validator: pwd2Valid, trigger: 'blur', required: true }],
            phone: [{ validator: phoneValid, trigger: 'blur', required: true }],
            smsCode: [{ validator: smsCodeValid, trigger: 'blur', required: true }],
        });
        const loginRules = reactive({
            account: [{ validator: accountValid, trigger: 'blur', required: true }],
            password: [{ validator: passwordValid, trigger: 'blur', required: true }]
        });
        let countdownId = ref();
        const curTime = ref(timeLimit);
        const clearCountdown = () => {
            if (countdownId.value)
                clearInterval(countdownId.value);
            curTime.value = timeLimit;
            countdownId.value = null;
        };
        const getSmsCode = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            console.log('countdownId', countdownId.value);
            if (countdownId.value)
                return;
            try {
                let checkRes = yield signUpFormEl.value.validateField('phone');
                if (!checkRes)
                    return;
                countdownId.value = setInterval(() => {
                    if (curTime.value > 0) {
                        curTime.value--;
                    }
                    else {
                        clearCountdown();
                    }
                }, 1000);
                try {
                    let res = yield (0, user_1.getSmsCode)(signUpResetForm.phone);
                    console.log(res);
                    if (res.code !== 1000) {
                        throw new Error(res.message);
                    }
                    one_message_1.oneMessage.success("发送验证码成功");
                }
                catch (e) {
                    one_message_1.oneMessage.error(`发送验证码失败, ${e.message}`);
                    throw e;
                }
            }
            catch (e) {
                console.log(e);
            }
        });
        function login() {
            var _a;
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                try {
                    (0, loading_1.openLoading)({ text: "正在登录" });
                    let { account, password } = loginForm;
                    account = account.trim();
                    if (isSavePwd.value) {
                        let saveInfo = JSON.stringify({ account, password });
                        localStorage.setItem("userIdentity", (0, base64_1.stringToBase64)(saveInfo));
                    }
                    else {
                        localStorage.removeItem("userIdentity");
                    }
                    if (!account || !password) {
                        one_message_1.oneMessage.error('请填写账号密码');
                        return;
                    }
                    const res = yield (0, user_1.login)(account, password);
                    if ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.token) {
                        yield router_1.default.push('/ide');
                    }
                    else {
                        throw new Error(res.message || res.msg);
                    }
                }
                catch (e) {
                    console.error(e);
                    if (e.message === 'Network Error') {
                        (0, one_message_1.oneMessage)({ message: `网络错误，登录失败，请检查网络后重试！`, type: 'error' });
                    }
                    else {
                        (0, one_message_1.oneMessage)({ message: `登录失败，${e.message}`, type: 'error' });
                    }
                }
                finally {
                    (0, loading_1.closeLoading)();
                }
            });
        }
        const signup = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!signUpFormEl.value) {
                return;
            }
            if (isSigning.value)
                return;
            isSigning.value = true;
            try {
                let checkRes = yield signUpFormEl.value.validate();
                if (!checkRes)
                    return;
                let params = {
                    password: signUpResetForm.pwd,
                    smsCode: signUpResetForm.smsCode,
                    phone: signUpResetForm.phone
                };
                let res = yield (0, user_1.signUp)(params);
                if (res.code === 1000) {
                    signUpFormEl.value.resetFields();
                    one_message_1.oneMessage.success('注册成功');
                    curFormMode.value = FORM_MODE.LOGIN;
                }
                else {
                    one_message_1.oneMessage.error(res.message);
                }
            }
            catch (e) {
                console.log(e);
            }
            finally {
                isSigning.value = false;
            }
        });
        const reset = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!signUpFormEl.value) {
                return;
            }
            if (isChanging.value)
                return;
            isChanging.value = true;
            try {
                let checkRes = yield signUpFormEl.value.validate();
                if (!checkRes)
                    return;
                const { pwd, smsCode, phone } = signUpResetForm;
                let res = yield (0, user_1.resetPwd)({ password: pwd, smsCode, phone });
                if (res.code === 1000) {
                    one_message_1.oneMessage.success(`重置成功！`);
                    curFormMode.value = FORM_MODE.LOGIN;
                    signUpFormEl.value.resetFields();
                }
                else {
                    one_message_1.oneMessage.error(`重置失败！${res.message}`);
                }
            }
            catch (e) {
                console.error(e);
            }
            finally {
                isChanging.value = false;
            }
        });
        onBeforeMount(() => {
            let userIdentityStr = localStorage.getItem('userIdentity');
            if (userIdentityStr) {
                try {
                    let userIdentityObj = JSON.parse((0, base64_1.base64ToString)(userIdentityStr));
                    loginForm.account = userIdentityObj.account;
                    loginForm.password = userIdentityObj.password;
                    isSavePwd.value = true;
                }
                catch (e) {
                    console.log(e);
                }
            }
        });
        return (_ctx, _cache) => {
            const _component_el_button = (0, vue_2.resolveComponent)("el-button");
            const _component_el_text = (0, vue_2.resolveComponent)("el-text");
            const _component_el_input = (0, vue_2.resolveComponent)("el-input");
            const _component_el_form_item = (0, vue_2.resolveComponent)("el-form-item");
            const _component_View = (0, vue_2.resolveComponent)("View");
            const _component_el_icon = (0, vue_2.resolveComponent)("el-icon");
            const _component_el_form = (0, vue_2.resolveComponent)("el-form");
            const _component_el_checkbox = (0, vue_2.resolveComponent)("el-checkbox");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                _hoisted_2,
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        ((0, vue_2.unref)(curFormMode) === FORM_MODE.LOGIN)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                _hoisted_5,
                                (0, vue_2.createVNode)(_component_el_text, { id: "header-btn-wrap" }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        _hoisted_6,
                                        (0, vue_2.createVNode)(_component_el_button, {
                                            link: "",
                                            type: "primary",
                                            onClick: _cache[0] || (_cache[0] = ($event) => (curFormMode.value = FORM_MODE.SIGN_UP))
                                        }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createTextVNode)("点此注册")
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ], 64))
                            : (0, vue_2.createCommentVNode)("", true),
                        ((0, vue_2.unref)(curFormMode) === FORM_MODE.SIGN_UP)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                                _hoisted_7,
                                (0, vue_2.createVNode)(_component_el_text, { id: "header-btn-wrap" }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        _hoisted_8,
                                        (0, vue_2.createVNode)(_component_el_button, {
                                            link: "",
                                            type: "primary",
                                            onClick: _cache[1] || (_cache[1] = ($event) => { curFormMode.value = FORM_MODE.LOGIN; resetSignUpResetForm(); })
                                        }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createTextVNode)("点此登录")
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ], 64))
                            : (0, vue_2.createCommentVNode)("", true),
                        ((0, vue_2.unref)(curFormMode) === FORM_MODE.RESET_PWD)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 2 }, [
                                _hoisted_9,
                                (0, vue_2.createVNode)(_component_el_text, { id: "header-btn-wrap" }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createVNode)(_component_el_button, {
                                            link: "",
                                            type: "primary",
                                            onClick: _cache[2] || (_cache[2] = ($event) => { curFormMode.value = FORM_MODE.LOGIN; resetSignUpResetForm(); })
                                        }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createTextVNode)("返回登录")
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ], 64))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    ((0, vue_2.unref)(curFormMode) === FORM_MODE.LOGIN)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_form, {
                            key: 0,
                            "label-width": "80",
                            "require-asterisk-position": "right",
                            rules: (0, vue_2.unref)(loginRules),
                            model: (0, vue_2.unref)(loginForm)
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(_component_el_form_item, {
                                    label: "用户名",
                                    prop: "account"
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createVNode)(_component_el_input, {
                                            type: "text",
                                            placeholder: "输入用户名",
                                            modelValue: (0, vue_2.unref)(loginForm).account,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (((0, vue_2.unref)(loginForm).account) = $event)),
                                            maxlength: "15"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_form_item, {
                                    label: "密码",
                                    prop: "password"
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createVNode)(_component_el_input, {
                                            type: (0, vue_2.unref)(showPassword) ? 'text' : 'password',
                                            placeholder: "输入密码",
                                            modelValue: (0, vue_2.unref)(loginForm).password,
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => (((0, vue_2.unref)(loginForm).password) = $event)),
                                            onKeyup: (0, vue_2.withKeys)(login, ["enter"])
                                        }, {
                                            suffix: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createVNode)(_component_el_icon, {
                                                    onMousedown: _cache[4] || (_cache[4] = ($event) => (showPassword.value = true)),
                                                    onMouseleave: _cache[5] || (_cache[5] = ($event) => (showPassword.value = false)),
                                                    onMouseup: _cache[6] || (_cache[6] = ($event) => (showPassword.value = false)),
                                                    onTouchstart: _cache[7] || (_cache[7] = ($event) => (showPassword.value = true)),
                                                    onTouchend: _cache[8] || (_cache[8] = ($event) => (showPassword.value = false))
                                                }, {
                                                    default: (0, vue_2.withCtx)(() => [
                                                        (0, vue_2.createVNode)(_component_View)
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }, 8, ["type", "modelValue"])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 8, ["rules", "model"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    ((0, vue_2.unref)(curFormMode) === FORM_MODE.SIGN_UP)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_form, {
                            key: 1,
                            "label-width": "80",
                            rules: (0, vue_2.unref)(signUpResetRules),
                            model: (0, vue_2.unref)(signUpResetForm),
                            ref_key: "signUpFormEl",
                            ref: signUpFormEl,
                            "require-asterisk-position": "right"
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(_component_el_form_item, {
                                    label: "手机号",
                                    prop: "phone"
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createVNode)(_component_el_input, {
                                            type: "text",
                                            placeholder: "输入手机号",
                                            modelValue: (0, vue_2.unref)(signUpResetForm).phone,
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => (((0, vue_2.unref)(signUpResetForm).phone) = $event))
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_form_item, {
                                    label: "验证码",
                                    prop: "smsCode"
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                            (0, vue_2.createVNode)(_component_el_input, {
                                                type: "text",
                                                placeholder: "输入验证码",
                                                modelValue: (0, vue_2.unref)(signUpResetForm).smsCode,
                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => (((0, vue_2.unref)(signUpResetForm).smsCode) = $event))
                                            }, null, 8, ["modelValue"]),
                                            (0, vue_2.createVNode)(_component_el_button, {
                                                onClick: getSmsCode,
                                                disabled: (0, vue_2.unref)(countdownId),
                                                class: "sms-btn"
                                            }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(countdownId) ? `${(0, vue_2.unref)(curTime)}秒` : "获取验证码"), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["disabled"])
                                        ])
                                    ]),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_form_item, {
                                    label: "密码",
                                    prop: "pwd"
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createVNode)(_component_el_input, {
                                            type: (0, vue_2.unref)(showPassword) ? 'text' : 'password',
                                            placeholder: "输入密码",
                                            modelValue: (0, vue_2.unref)(signUpResetForm).pwd,
                                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => (((0, vue_2.unref)(signUpResetForm).pwd) = $event)),
                                            onKeyup: (0, vue_2.withKeys)(login, ["enter"])
                                        }, {
                                            suffix: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createVNode)(_component_el_icon, {
                                                    onMousedown: _cache[12] || (_cache[12] = ($event) => (showPassword.value = true)),
                                                    onMouseleave: _cache[13] || (_cache[13] = ($event) => (showPassword.value = false)),
                                                    onMouseup: _cache[14] || (_cache[14] = ($event) => (showPassword.value = false)),
                                                    onTouchstart: _cache[15] || (_cache[15] = ($event) => (showPassword.value = true)),
                                                    onTouchend: _cache[16] || (_cache[16] = ($event) => (showPassword.value = false))
                                                }, {
                                                    default: (0, vue_2.withCtx)(() => [
                                                        (0, vue_2.createVNode)(_component_View)
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }, 8, ["type", "modelValue"])
                                    ]),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_form_item, {
                                    label: "确认密码",
                                    prop: "pwd2"
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createVNode)(_component_el_input, {
                                            type: (0, vue_2.unref)(showPwd2) ? 'text' : 'password',
                                            placeholder: "输入密码",
                                            modelValue: (0, vue_2.unref)(signUpResetForm).pwd2,
                                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => (((0, vue_2.unref)(signUpResetForm).pwd2) = $event)),
                                            onKeyup: (0, vue_2.withKeys)(login, ["enter"])
                                        }, {
                                            suffix: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createVNode)(_component_el_icon, {
                                                    onMousedown: _cache[18] || (_cache[18] = ($event) => (showPwd2.value = true)),
                                                    onMouseleave: _cache[19] || (_cache[19] = ($event) => (showPwd2.value = false)),
                                                    onMouseup: _cache[20] || (_cache[20] = ($event) => (showPwd2.value = false)),
                                                    onTouchstart: _cache[21] || (_cache[21] = ($event) => (showPwd2.value = true)),
                                                    onTouchend: _cache[22] || (_cache[22] = ($event) => (showPwd2.value = false))
                                                }, {
                                                    default: (0, vue_2.withCtx)(() => [
                                                        (0, vue_2.createVNode)(_component_View)
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }, 8, ["type", "modelValue"])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 8, ["rules", "model"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    ((0, vue_2.unref)(curFormMode) === FORM_MODE.RESET_PWD)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_form, {
                            key: 2,
                            "label-width": "80",
                            rules: (0, vue_2.unref)(signUpResetRules),
                            model: (0, vue_2.unref)(signUpResetForm),
                            ref_key: "signUpFormEl",
                            ref: signUpFormEl,
                            "require-asterisk-position": "right"
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(_component_el_form_item, {
                                    label: "手机号",
                                    prop: "phone"
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createVNode)(_component_el_input, {
                                            type: "text",
                                            placeholder: "输入手机号",
                                            modelValue: (0, vue_2.unref)(signUpResetForm).phone,
                                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => (((0, vue_2.unref)(signUpResetForm).phone) = $event))
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_form_item, {
                                    label: "验证码",
                                    prop: "smsCode"
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                            (0, vue_2.createVNode)(_component_el_input, {
                                                type: "text",
                                                placeholder: "输入验证码",
                                                modelValue: (0, vue_2.unref)(signUpResetForm).smsCode,
                                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => (((0, vue_2.unref)(signUpResetForm).smsCode) = $event))
                                            }, null, 8, ["modelValue"]),
                                            (0, vue_2.createVNode)(_component_el_button, {
                                                onClick: getSmsCode,
                                                disabled: (0, vue_2.unref)(countdownId),
                                                class: "sms-btn"
                                            }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(countdownId) ? `${(0, vue_2.unref)(curTime)}秒` : "获取验证码"), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["disabled"])
                                        ])
                                    ]),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_form_item, {
                                    label: "密码",
                                    prop: "pwd"
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createVNode)(_component_el_input, {
                                            type: (0, vue_2.unref)(showPassword) ? 'text' : 'password',
                                            placeholder: "输入密码",
                                            modelValue: (0, vue_2.unref)(signUpResetForm).pwd,
                                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event) => (((0, vue_2.unref)(signUpResetForm).pwd) = $event)),
                                            onKeyup: (0, vue_2.withKeys)(login, ["enter"])
                                        }, {
                                            suffix: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createVNode)(_component_el_icon, {
                                                    onMousedown: _cache[26] || (_cache[26] = ($event) => (showPassword.value = true)),
                                                    onMouseleave: _cache[27] || (_cache[27] = ($event) => (showPassword.value = false)),
                                                    onMouseup: _cache[28] || (_cache[28] = ($event) => (showPassword.value = false)),
                                                    onTouchstart: _cache[29] || (_cache[29] = ($event) => (showPassword.value = true)),
                                                    onTouchend: _cache[30] || (_cache[30] = ($event) => (showPassword.value = false))
                                                }, {
                                                    default: (0, vue_2.withCtx)(() => [
                                                        (0, vue_2.createVNode)(_component_View)
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }, 8, ["type", "modelValue"])
                                    ]),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_form_item, {
                                    label: "确认密码",
                                    prop: "pwd2"
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createVNode)(_component_el_input, {
                                            type: (0, vue_2.unref)(showPwd2) ? 'text' : 'password',
                                            placeholder: "输入密码",
                                            modelValue: (0, vue_2.unref)(signUpResetForm).pwd2,
                                            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event) => (((0, vue_2.unref)(signUpResetForm).pwd2) = $event)),
                                            onKeyup: (0, vue_2.withKeys)(login, ["enter"])
                                        }, {
                                            suffix: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createVNode)(_component_el_icon, {
                                                    onMousedown: _cache[32] || (_cache[32] = ($event) => (showPwd2.value = true)),
                                                    onMouseleave: _cache[33] || (_cache[33] = ($event) => (showPwd2.value = false)),
                                                    onMouseup: _cache[34] || (_cache[34] = ($event) => (showPwd2.value = false)),
                                                    onTouchstart: _cache[35] || (_cache[35] = ($event) => (showPwd2.value = true)),
                                                    onTouchend: _cache[36] || (_cache[36] = ($event) => (showPwd2.value = false))
                                                }, {
                                                    default: (0, vue_2.withCtx)(() => [
                                                        (0, vue_2.createVNode)(_component_View)
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }, 8, ["type", "modelValue"])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 8, ["rules", "model"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createElementVNode)("div", _hoisted_12, [
                        ((0, vue_2.unref)(curFormMode) === FORM_MODE.LOGIN)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                (0, vue_2.createVNode)(_component_el_checkbox, {
                                    modelValue: (0, vue_2.unref)(isSavePwd),
                                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event) => ((0, vue_2.isRef)(isSavePwd) ? (isSavePwd).value = $event : null)),
                                    label: "记住密码"
                                }, null, 8, ["modelValue"]),
                                _hoisted_13,
                                (0, vue_2.createVNode)(_component_el_button, {
                                    class: "submit__button",
                                    type: "primary",
                                    size: "large",
                                    onClick: login
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createTextVNode)("立即登录")
                                    ]),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_button, {
                                    id: "forget-pwd",
                                    size: "small",
                                    link: "",
                                    type: "primary",
                                    onClick: _cache[39] || (_cache[39] = ($event) => (curFormMode.value = FORM_MODE.RESET_PWD))
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createTextVNode)("忘记密码")
                                    ]),
                                    _: 1
                                })
                            ], 64))
                            : (0, vue_2.createCommentVNode)("", true),
                        ((0, vue_2.unref)(curFormMode) === FORM_MODE.SIGN_UP)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_button, {
                                key: 1,
                                class: "submit__button",
                                type: "primary",
                                size: "large",
                                onClick: signup,
                                loading: (0, vue_2.unref)(isSigning),
                                disabled: (0, vue_2.unref)(isSigning)
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createTextVNode)("立即注册")
                                ]),
                                _: 1
                            }, 8, ["loading", "disabled"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        ((0, vue_2.unref)(curFormMode) === FORM_MODE.RESET_PWD)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_button, {
                                key: 2,
                                class: "submit__button",
                                type: "primary",
                                size: "large",
                                onClick: reset,
                                loading: (0, vue_2.unref)(isChanging),
                                disabled: (0, vue_2.unref)(isChanging)
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createTextVNode)("立即重置")
                                ]),
                                _: 1
                            }, 8, ["loading", "disabled"]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ])
                ])
            ]));
        };
    }
});
